import React from 'react';

// Official EIG logo (company asset).
export default function Logo({ className = '' }) {
  return (
    <div className={`flex items-center ${className}`}>
      <img
        src="/eig-logo.png"
        alt="Education Intelligence Group"
        className="h-12 w-auto"
        loading="eager"
      />
    </div>
  );
}
